import { SearchIcon } from 'lucide-react'
import React from 'react'

import { cn } from '@/modules/shared/lib/utils'

export type SearchProps = React.InputHTMLAttributes<HTMLInputElement> & {
	onClickSearchIcon?: () => void
}

const Search = React.forwardRef<HTMLInputElement, SearchProps>(
	({ className, onClickSearchIcon, ...props }, ref) => {
		return (
			<div
				className={cn(
					'flex flex-1 w-full  items-center rounded-md border border-input bg-white px-3 text-md ring-offset-background focus-within:ring-1 focus-within:ring-ring focus-within:ring-offset-0',
					className,
					props?.disabled && 'cursor-not-allowed opacity-50 bg-white',
				)}
			>
				<input
					{...props}
					ref={ref}
					autoComplete="off"
					className="w-full mr-1 h-12 placeholder:text-muted-foreground text-sm focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-white"
				/>
				<SearchIcon
					className="h-[16px] w-[16px] cursor-pointer"
					onClick={onClickSearchIcon}
				/>
			</div>
		)
	},
)

Search.displayName = 'Search'

export { Search }
